import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { userSession } from "../../services/client-login-service";
import Spinner from "../Loading&Spinners/Spinner";

const FreeDownload = () => {
  //
  // Add loading state
  const [isLoading, setIsLoading] = useState(true);

  const actionGames = [
    {
      thumbnail: "sniper-3d.png",
      name: "Sniper 3d",
      url: "sniper-3d-mod_4.35.13-an1.com.apk",
    },

    {
      thumbnail: "war-machines.png",
      name: "War Machines",
      url: "war-machines_8.33.1-an1.com.apk",
    },
  ];

  const NewGames = [
    {
      thumbnail: "CarTrader.png",
      name: "Car Trader Simulator",
      url: "sniper-3d-mod_4.35.13-an1.com.apk",
    },
    {
      thumbnail: "crash.png",
      name: "Smash Hit",
      url: "Tapventures-%28MOD%29_6.7-Android-1.com.apk",
    },
    {
      thumbnail: "magictiles.png",
      name: "Magic Tiles 3",
      url: "war-machines_8.33.1-an1.com.apk",
    },
  ];

  const strategyGames = [
    {
      thumbnail: "alien-creep.png",
      name: "Alien Creep",
      url: "alien-creep-td-mod_2.32.4-an1.com.apksniper-3d-mod_4.35.13-an1.com.apk",
    },
    {
      thumbnail: "bid-wars-2.png",
      name: "Bid Wars",
      url: "bid-wars-mod_2.57-an1.com.apk",
    },
  ];

  const racingGames = [
    {
      thumbnail: "drag-racing11.jpg",
      name: "Drag Racing",
      url: "drag-racing-mod_4.1.7-an1.com.apk",
    },

    {
      thumbnail: "moto-rider-go.jpg",
      name: "Moto Rider",
      url: "moto-rider-go-mod_1.92.1-an1.com.apk",
    },
  ];

  const shootingGames = [
    {
      thumbnail: "bowmasters.png",
      name: "Bowmasters",
      url: "bowmasters-mod_6.0.7-an1.com.apk",
    },

    {
      thumbnail: "Magnum.jpg",
      name: "Magnum",
      url: "Magnum_v1.0596_mod_apkdone.com.apk",
    },
    {
      thumbnail: "Supreme-Duelist-Stickman.jpg",
      name: "Supreme Duelist",
      url: "Supreme-Duelist-Stickman-3.5.2-Mod-www.ReXdl.com.apk",
    },
  ];

  // useEffect(() => {
  //   localStorage.setItem("UserSessionId", "2582690");
  //   const fetchData = async () => {
  //     try {
  //       const session = {
  //         userSessionId: localStorage.getItem("UserSessionId"),
  //         sessionType: "Games",
  //         userId: localStorage.getItem("jwt_j"),
  //       };

  //       await userSession(session);
  //       // Additional data loading logic if needed...

  //       setIsLoading(false);
  //     } catch (error) {
  //       console.error("Error loading data:", error);
  //       // Handle error loading data...
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay with setTimeout
    const timer = setTimeout(() => {
      setLoading(false); // Set loading to false after a delay
    }, 100); // Adjust the delay as needed

    // Clean up the timer when the component unmounts
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`App ${loading ? "loading" : ""}`}>
      {loading && <Spinner />}
      <div style={{ visibility: isLoading ? "hidden" : "visible" }}>
        {!loading && (
          <div>
            <section className="games-filter">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div
                      className="filter-wrapp"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div className="download-text">
                        Download Your Favorite Games for free!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="game-play-section download-game-play-section"
              style={{}}
            >
              <h3
                class="CETEGORIES"
                style={{ fontSize: "1em", marginBottom: "18px" }}
              >
                ACTION
              </h3>
              <div
                className="games-container"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "16px",
                  marginBottom: "25px",
                }}
              >
                {actionGames.map((game, index) => (
                  <div
                    key={index}
                    className="single-play1 download-game-box "
                    style={{ marginBottom: "20px" }}
                  >
                    <div
                      className="image"
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "10px",
                        marginBottom: "6px",
                      }}
                    >
                      <img
                        src={`assets/Icons/${game.thumbnail}`}
                        alt="games-images"
                        className="zoomable-image download-game-image"
                        loading="lazy"
                      />
                    </div>
                    <span style={{ fontSize: "14px" }}>{game.name}</span>
                    <div
                      className="download-like-div"
                      style={{
                        display: "flex",
                        alignItems: "end",
                        position: "relative",
                        marginTop: "10px",
                        width: "100%",
                      }}
                    >
                      <a
                        className="download-button"
                        style={{
                          display: "flex",
                          fontSize: "16px",
                          width: "100%",
                          justifyContent: "center",
                        }}
                        href={`https://cdn-content.mmsdp.com/newgames-may-2/Downloadable%20Games/Action/${game.url}`}
                        // onClick={() => handleClick(`assets/Icons/${game.thumbnail}`, game.url)}
                      >
                        Download
                      </a>
                    </div>
                  </div>
                ))}
              </div>
              <h1
                class="CETEGORIES"
                style={{ fontSize: "1em", marginBottom: "18px" }}
              >
                STRATEGY
              </h1>
              <div
                className="games-container"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "20px",
                  marginBottom: "25px",
                }}
              >
                {strategyGames.map((game, index) => (
                  <div
                    key={index}
                    className="single-play1 download-game-box"
                    style={{ marginBottom: "20px" }}
                  >
                    <div
                      className="image"
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "10px",
                        marginBottom: "6px",
                      }}
                    >
                      <img
                        src={`assets/Icons/${game.thumbnail}`}
                        alt="games-images"
                        className="zoomable-image download-game-image"
                        loading="lazy"
                      />
                    </div>
                    <span style={{ fontSize: "14px" }}>{game.name}</span>
                    <div
                      className="download-like-div"
                      style={{
                        display: "flex",
                        alignItems: "end",
                        marginTop: "10px",
                      }}
                    >
                      <a
                        className="download-button"
                        style={{
                          display: "flex",
                          fontSize: "16px",
                          justifyContent: "center",
                          width: "100%",
                        }}
                        href={`https://cdn-content.mmsdp.com/newgames-may-2/Downloadable%20Games/Strategy/${game.url}`}
                        // onClick={() => handleClick(`assets/Icons/${game.thumbnail}`, game.url)}
                      >
                        Download
                      </a>
                    </div>
                  </div>
                ))}
              </div>
              <h1
                class="CETEGORIES"
                style={{ fontSize: "1em", marginBottom: "18px" }}
              >
                RACING
              </h1>
              <div
                className="games-container"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "20px",
                  marginBottom: "25px",
                }}
              >
                {racingGames.map((game, index) => (
                  <div
                    key={index}
                    className="single-play1 download-game-box"
                    style={{ marginBottom: "20px" }}
                  >
                    <div
                      className="image"
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "10px",
                        marginBottom: "6px",
                      }}
                    >
                      <img
                        src={`assets/Icons/${game.thumbnail}`}
                        alt="games-images"
                        className="zoomable-image download-game-image"
                        loading="lazy"
                      />
                    </div>
                    <span style={{ fontSize: "14px" }}>{game.name}</span>
                    <div
                      className="download-like-div"
                      style={{
                        display: "flex",
                        alignItems: "end",
                        position: "relative",
                        marginTop: "10px",
                      }}
                    >
                      <a
                        className="download-button"
                        style={{
                          display: "flex",
                          fontSize: "16px",
                          justifyContent: "center",
                          width: "100%",
                        }}
                        href={`https://cdn-content.mmsdp.com/newgames-may-2/Downloadable%20Games/Racing/${game.url}`}
                        // onClick={() => handleClick(`assets/Icons/${game.thumbnail}`, game.url)}
                      >
                        Download
                      </a>
                    </div>
                  </div>
                ))}
              </div>
              <h1
                class="CETEGORIES"
                style={{ fontSize: "1em", marginBottom: "18px" }}
              >
                SHOOTING
              </h1>
              <div
                className="games-container"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "20px",
                  marginBottom: "25px",
                }}
              >
                {shootingGames.map((game, index) => (
                  <div
                    key={index}
                    className="single-play1 download-game-box"
                    style={{ marginBottom: "20px" }}
                  >
                    <div
                      className="image"
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "10px",
                        marginBottom: "6px",
                      }}
                    >
                      <img
                        src={`assets/Icons/${game.thumbnail}`}
                        alt="games-images"
                        className="zoomable-image download-game-image"
                        loading="lazy"
                      />
                    </div>
                    <span style={{ fontSize: "14px" }}>{game.name}</span>
                    <div
                      className="download-like-div"
                      style={{
                        display: "flex",
                        alignItems: "end",
                        position: "relative",
                        marginTop: "10px",
                      }}
                    >
                      <a
                        className="download-button"
                        style={{
                          display: "flex",
                          fontSize: "16px",
                          justifyContent: "center",
                          width: "100%",
                        }}
                        href={`https://cdn-content.mmsdp.com/newgames-may-2/Downloadable%20Games/Shooter/${game.url}`}
                      >
                        Download
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              <h1
                class="CETEGORIES"
                style={{ fontSize: "1em", marginBottom: "18px" }}
              >
                New Arrivals
              </h1>
              <div
                className="games-container"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "20px",
                  marginBottom: "25px",
                }}
              >
                {NewGames.map((game, index) => (
                  <div
                    key={index}
                    className="single-play1 download-game-box"
                    style={{ marginBottom: "20px" }}
                  >
                    <div
                      className="image"
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "10px",
                        marginBottom: "6px",
                      }}
                    >
                      <img
                        src={`assets/Icons/NewArivals/${game.thumbnail}`}
                        alt="games-images"
                        className="zoomable-image download-game-image"
                        loading="lazy"
                      />
                    </div>
                    <span style={{ fontSize: "14px" }}>{game.name}</span>
                    <div
                      className="download-like-div"
                      style={{
                        display: "flex",
                        alignItems: "end",
                        position: "relative",
                        marginTop: "10px",
                      }}
                    >
                      <a
                        className="download-button"
                        style={{
                          display: "flex",
                          fontSize: "16px",
                          justifyContent: "center",
                          width: "100%",
                        }}
                        href={`https://cdn-content.mmsdp.com/newarrival/${game.url}`}
                      >
                        Download
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>
        )}
      </div>
    </div>
  );
};
export default FreeDownload;
